const IMAGE_EXTS = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'heic', 'heif'];
const PDF_EXTS = ['pdf'];
const EXCEL_EXTS = ['xls', 'xlsx', 'csv'];

export const inferExtFromUrl = (url, ext) => {
  if (ext) {
    return String(ext).toLowerCase().replace(/^\./, '');
  }
  if (!url) return '';
  const clean = String(url).split('?')[0];
  const part = clean.split('.').pop();
  return part ? part.toLowerCase() : '';
};

export const getAttachmentExt = (attachment) => {
  if (!attachment) return '';
  if (attachment.extensao) {
    return String(attachment.extensao).toLowerCase().replace(/^\./, '');
  }
  if (attachment.file?.name) {
    return attachment.file.name.split('.').pop().toLowerCase();
  }
  return inferExtFromUrl(attachment.downloadUrl, attachment.extensao);
};

export const getAttachmentMime = (attachment) =>
  attachment?.mimeType || attachment?.file?.type || '';

export const isImageAttachment = (attachment) => {
  const mime = getAttachmentMime(attachment);
  if (mime && mime.startsWith('image/')) return true;
  return IMAGE_EXTS.includes(getAttachmentExt(attachment));
};

export const isPdfAttachment = (attachment) => {
  const mime = getAttachmentMime(attachment);
  if (mime === 'application/pdf') return true;
  return PDF_EXTS.includes(getAttachmentExt(attachment));
};

export const isExcelAttachment = (attachment) => {
  const mime = getAttachmentMime(attachment);
  if (
    mime === 'application/vnd.ms-excel'
    || mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    || mime === 'text/csv'
  ) {
    return true;
  }
  const ext = getAttachmentExt(attachment);
  return EXCEL_EXTS.includes(ext);
};

export const canPreviewAttachment = (attachment) =>
  isImageAttachment(attachment)
  || isPdfAttachment(attachment)
  || isExcelAttachment(attachment);

export const getAttachmentDisplayName = (attachment) => {
  if (!attachment) return 'Arquivo';
  if (attachment.nome) return attachment.nome;
  if (attachment.title) return attachment.title;
  const ext = getAttachmentExt(attachment);
  return ext ? `arquivo.${ext}` : 'Arquivo';
};

export const getDownloadFileName = (attachment) => {
  const name = getAttachmentDisplayName(attachment);
  const ext = getAttachmentExt(attachment);
  if (ext && !name.toLowerCase().endsWith(`.${ext}`)) {
    return `${name}.${ext}`;
  }
  return name;
};

/** Normaliza item vindo da API/saga para o contrato do AnexoPreviewV2. */
export const normalizeAttachment = (item) => ({
  nome: item.nome || item.title || 'Arquivo',
  extensao: inferExtFromUrl(item.downloadUrl, item.extensao),
  title: item.title || item.nome || 'Arquivo',
  downloadUrl: item.downloadUrl || item.url,
  mimeType: item.mimeType,
  file: item.file || null,
  src: item.src || null,
});
